/* eslint-env browser */

const axios = require('axios')

const DomHelper = require('../../client/clientjs/dom-helper')

export default mapboxgl => {
  mapboxgl.accessToken = window.initialState.config.mapboxAccessToken
  const allLoadedMapboxes = []
  const maps = DomHelper.queryAll('.contest-map-zones')
  ;(maps || []).forEach(map => {
    const contestId = DomHelper.data(map, 'contest-id')
    const styleId =
      DomHelper.data(map, 'mapbox-style-id') || 'mapbox://styles/philippeauriach/cj6w4qfvd018h2rqvvvj9ge00'
    if (!contestId) {
      return
    }
    const mapbox = new mapboxgl.Map({
      container: `contest-${contestId}-zones-map`,
      style: styleId,
    })
    mapbox.loadZone = function(zoneId) {
      if (!zoneId) {
        zoneId = ''
      }
      setTimeout(() => {
        axios.get(`/api/map/contests/${contestId}/zonesBoundingBoxes/${zoneId}`).then(res => {
          if (res.data && res.data.length > 0) {
            const datas = res.data.filter(elt => !!elt.coordinates)
            if (datas.length > 0 && datas[0].coordinates.length > 0) {
              const zeBounds = datas.reduce(function(bounds, data) {
                return data.coordinates[0].reduce(function(bounds2, coord) {
                  return bounds2.extend(coord)
                }, bounds)
              }, new mapboxgl.LngLatBounds(datas[0].coordinates[0][0], datas[0].coordinates[0][0]))
              mapbox.fitBounds(zeBounds, { padding: 20 })
            }
          }
        })
      }, 0)
    }
    allLoadedMapboxes.push(mapbox)
    mapbox.on('load', () => {
      mapbox.addSource('fishfriender-contests', {
        type: 'vector',
        tiles: [`${window.origin}/api/map/contests/${contestId}/zones/{z}/{x}/{y}.mvt`],
      })
      mapbox.addLayer({
        id: 'contests-zones',
        source: 'fishfriender-contests',
        'source-layer': 'zones',
        type: 'line',
        paint: {
          'line-color': 'blue',
          'line-width': 2,
        },
      })
      mapbox.addLayer({
        id: 'contests-zones-fill',
        source: 'fishfriender-contests',
        'source-layer': 'zones',
        type: 'fill',
        paint: {
          'fill-color': 'blue',
          'fill-opacity': 0.2,
        },
      })
      const zones = DomHelper.queryAll('.contest-map-zone-btn')
      zones.forEach(btn => {
        const zoneId = DomHelper.data(btn, 'contest-zone-id')
        btn.onclick = () => {
          mapbox.loadZone(zoneId)
        }
        if (zones.length === 1) {
          btn.onclick()
        }
      })
      if (window.initialState.contestZonesPOIS) {
        ;(window.initialState.contestZonesPOIS || []).forEach(poi => {
          if (poi.lat && poi.lng) {
            const el = document.createElement('div')
            el.className = 'marker'

            new mapboxgl.Marker({
              color: poi.color || 'orange',
            })
              .setLngLat([poi.lng, poi.lat])
              .setPopup(new mapboxgl.Popup({ offset: 25 }).setHTML(`<b>${poi.title}</b><p>${poi.description}</p>`))
              .addTo(mapbox)
          }
        })
      }
    })
  })
}
